import { createFileRoute } from '@tanstack/react-router';
import { TriggeredNewRedirectRoute } from './-journeys-redirects';

function TriggeredNewRoute() {
  const { workspaceId } = Route.useParams();
  return <TriggeredNewRedirectRoute workspaceId={workspaceId} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/triggered/new')({
  component: TriggeredNewRoute,
});
